import React, { useState, useEffect, useRef } from "react";
import coverbg from "../assets/largecover.jpg";
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBCollapse,
  MDBInput,
  MDBCardHeader,
  MDBIcon,
  MDBCardImage,
} from "mdb-react-ui-kit";
import logonobg from "../assets/file.png"
import { MDBBadge } from "mdb-react-ui-kit";
import {
  MDBCarousel,
  MDBCarouselItem,

} from "mdb-react-ui-kit";
import {
  MDBFooter,

} from "mdb-react-ui-kit";


import {
  MDBTextArea,
} from "mdb-react-ui-kit";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import logo from "../assets/logo.png";
import logodark from "../assets/logodark.png";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Button from "react-bootstrap/Button";
import car from "../assets/car.png";
import minivan from "../assets/minibus.png";
import van from "../assets/van.png";
import prestige from "../assets/sportscar.png";
import carinv from "../assets/carinv.png";
import "../App.css";
import { Fab, Grid } from "@mui/material";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
} from "mdb-react-ui-kit";
import { MDBListGroup, MDBListGroupItem } from "mdb-react-ui-kit";

import adventure from "../assets/adventure.jpg";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateField } from "@mui/x-date-pickers/DateField";
import { DatePicker } from "@mui/x-date-pickers";

import para1 from "../assets/para1.jpg";

import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import {
  AddIcCallOutlined,
  ArrowForwardIosOutlined,
  BuildCircle,
  ContactPhoneOutlined,
  EditLocation,
  EmojiEvents,
  Favorite,
  Filter1,
  Filter2,
  Filter3,
  Filter4,
  FilterList,
  LocalGasStation,
  LocalOfferOutlined,
  LocationOffOutlined,
  LocationOnOutlined,
  Logout,
  Looks3,
  Looks4,
  LooksOne,
  LooksTwo,
  PeopleAlt,
  SensorDoor,
} from "@mui/icons-material";
import { Parallax } from "react-parallax";
import ReactCardCarousel from "react-card-carousel";

import logorahima from "../assets/logo.png"

import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import MediaQuery from "react-responsive"


import car3d from "../assets/car3d.png";
import car1 from "../assets/bmw-m5.jpg";
import car2 from "../assets/ferrari-enzo.jpg";

import car3 from "../assets/ford-raptor.jpg";
import car4 from "../assets/jeep-renegade.jpg";
import car5 from "../assets/mini-cooper.jpg";
import car6 from "../assets/vw-polo.jpg";
import Build from "react-card-carousel";

import {connect } from 'react-redux'
import PropTypes from 'prop-types'
import { logout } from "../actions/auth";
import cardb from "../assets/cardbg.jpg"
import hairloss from "../assets/hairloss.png";
import Navb from "./Navbar"


import Carousel from "react-bootstrap/Carousel";

import c1 from "../assets/c1.jpg"
import c2 from "../assets/c2.jpg"
import c3 from "../assets/c3.jpg"

import { AnimateOnChange } from "react-animation";

import { animations } from "react-animation";

import "react-animation/dist/keyframes.css";
import SocialMediaButtons from "./Langbar";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
    opacity: "0.6",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#141414",
      opacity: "0.6",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#141414",
      opacity: "0.6",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
    opacity: "0.6",
  },
}));

const steps = [
  "Unlock unparalleled adventures and memorable journeys with our vast fleet of vehicles tailored to suit every need, taste, and destination.",
  "Create an ad group",
  "Create an ad",
  "Create an ad",
];

function Home() {
  const [showNav, setShowNav] = useState(false);
  const [navBackground, setNavBackground] = useState(false);
  const navRef = useRef();
  navRef.current = navBackground;
  useEffect(() => {
    const handleScroll = () => {
      const show = window.scrollY > 50;
      if (navRef.current !== show) {
        setNavBackground(show);
      }
    };
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ref = useRef();

  //handling hover
  const [isShown, setIsShown] = useState(false);
  console.log(isShown);
  //handling inputs
  const [endroit1, setEndroit1] = useState("");

  //date time
  const [datedebut, setDateDeb] = useState("");

  //styling stepper
  const StepOneIcon = () => {
    return (
      <LooksOne
        sx={{
          fontSize: "40px",
          color: isHovered ? "#FEFEFE" : "#141414",
          opacity: "0.6",
        }}
      />
    );
  };

  const StepTwoIcon = () => {
    return (
      <LooksTwo
        color="#21BF18"
        sx={{ fontSize: "40px", color: "#141414", opacity: "0.6" }}
      />
    );
  };

  const StepThreeIcon = () => {
    return (
      <Looks3
        color="#141414"
        sx={{ fontSize: "40px", color: "#141414", opacity: "0.6" }}
      />
    );
  };
  const StepFourIcon = () => {
    return (
      <Looks4
        color="#141414"
        sx={{ fontSize: "40px", color: "#141414", opacity: "0.6" }}
      />
    );
  };

  //card styiling

  const Connected = (
    <Nav>
      <Nav.Link>
        <Button
          onClick={() => {
            logout();
          }}
          variant="outline-success"
        >
          {" "}
          <Logout /> Logout
        </Button>{" "}
      </Nav.Link>
    </Nav>
  );
  const NotConnected = (
    <Nav>
      <Nav.Link eventKey={2} href="#memes">
        {navBackground ? (
          <Button variant="outline-dark">Sign up</Button>
        ) : (
          <Button variant="outline-light">Sign up</Button>
        )}
      </Nav.Link>

      <Nav.Link>
        <Button variant="outline-success">Login</Button>{" "}
      </Nav.Link>
    </Nav>
  );

  //animation
  const texts = [ "un Meilleur Look", " Plus de  Confiance "]; // Array of texts to cycle through

  const [index, setIndex] = useState(0);

  const changeText = () => {
    setIndex((index + 1) % texts.length);
  };

  // Automatically change text every three seconds
  React.useEffect(() => {
    const interval = setInterval(changeText, 3000);
    return () => clearInterval(interval);
  });


    const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div style={{ position: "relative" }}>
      <Navb />

      <div
        class="bg-image coverHeight"
        style={{
          backgroundImage: `url(${coverbg})`,
          padding: "1%",
        }}
      >
        <div style={{ width: "50%", marginTop: "10%" }}>
          <h1
            className="mgup"
            style={{
              fontFamily: " 'Bebas Neue', sans-serif",
              color: "#FEFFFE",
              display: "inline-block",
              marginLeft: "15%",
              fontSize: "7vh",
            }}
          >
            Votre chemin vers{" "}
            <h1
              style={{
                color: "#03045E",
                display: "inline-block",
                fontSize: "7vh",
              }}
            >
              {" "}
              <AnimateOnChange
                animationIn="bounceIn"
                animationOut="bounceOut"
                durationOut={500}
              >
                {texts[index]}
              </AnimateOnChange>
            </h1>{" "}
            commence{" "}
            <h1
              style={{
                color: "#03045E ",
                display: "inline-block",
                fontSize: "7vh",
              }}
            >
              ici
            </h1>
          </h1>
        </div>

        <Box sx={{ width: "80%", marginLeft: "7%" }}>
          <MDBBtn
            color="info"
            style={{
              borderRadius: "15px",
              fontSize: "2vh",
              fontFamily: " 'Montserrat', Sans-Serif",
            }}
          >
            {" "}
            Prenez Rendez-vous
          </MDBBtn>
        </Box>
        <MediaQuery query="(min-device-width: 1024px)">
          <Box
            sx={{
              width: "60%",
              marginLeft: "5%",
              marginTop: "2%",
              borderRadius: "15px",
              color: "#141414",
            }}
          >
            <Stepper
              alternativeLabel
              activeStep={4}
              connector={<QontoConnector />}
            >
              <Step>
                <StepLabel
                  StepIconComponent={StepOneIcon}
                  sx={{ color: "white" }}
                  color="#141414"
                >
                  <a href="/Login">
                    <MDBCard
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                      style={{
                        backgroundColor: "transparent",
                        boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                        animation: animations.slideIn,
                        duration: 3000,
                        width: "100%",
                      }}
                      className="shake"
                    >
                      <MDBCardBody
                        style={{
                          padding: "10%",
                          width: "70%",
                          backgroundColor: isHovered ? "#FEFEFE" : "#141414",
                          borderRadius: "15px",
                          opacity: 0.6,
                          height: "150%",
                        }}
                      >
                        <MDBIcon fab icon="wpforms" color="info" size="3x" />
                        <h6
                          style={{
                            color: isHovered ? "#03045E" : "#FEFEFE",
                            fontFamily: " 'Bebas Neue', sans-serif",
                          }}
                        >
                          Remplissez Le Formulaire en ligne
                        </h6>
                      </MDBCardBody>
                    </MDBCard>
                  </a>
                </StepLabel>
              </Step>

              <Step>
                <StepLabel
                  StepIconComponent={StepTwoIcon}
                  sx={{ color: "white" }}
                  color="white"
                >
                  <MDBCard
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                      animation: animations.slideIn,

                      width: "100%",
                    }}
                  >
                    <MDBCardBody
                      style={{
                        padding: "10%",
                        width: "70%",
                        backgroundColor: "#141414",
                        borderRadius: "15px",
                        opacity: 0.6,
                        height: "150%",
                      }}
                    >
                      <MDBIcon far icon="calendar" color="info" size="3x" />
                      <h6
                        style={{
                          color: "#FEFEFE",
                          fontFamily: " 'Bebas Neue', sans-serif",
                        }}
                      >
                        On vous contactera avec une date
                      </h6>
                    </MDBCardBody>
                  </MDBCard>
                </StepLabel>
              </Step>

              <Step>
                <StepLabel
                  StepIconComponent={StepThreeIcon}
                  sx={{ color: "white" }}
                  color="white"
                >
                  <MDBCard
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                      animation: animations.slideIn,

                      width: "100%",
                    }}
                  >
                    <MDBCardBody
                      style={{
                        padding: "10%",
                        width: "70%",
                        backgroundColor: "#141414",
                        borderRadius: "15px",
                        opacity: 0.6,
                        height: "150%",
                      }}
                    >
                      <MDBIcon fas icon="video" color="info" size="3x" />
                      <h6
                        style={{
                          color: "#FEFEFE",
                          fontFamily: " 'Bebas Neue', sans-serif",
                        }}
                      >
                        Faites la teleconsultation
                      </h6>
                    </MDBCardBody>
                  </MDBCard>
                </StepLabel>
              </Step>

              <Step>
                <StepLabel
                  StepIconComponent={StepFourIcon}
                  sx={{ color: "white" }}
                  color="white"
                >
                  <MDBCard
                    style={{
                      backgroundColor: "transparent",
                      boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                      animation: animations.slideIn,

                      width: "100%",
                    }}
                  >
                    <MDBCardBody
                      style={{
                        padding: "10%",
                        width: "70%",
                        backgroundColor: "#141414",
                        borderRadius: "15px",
                        opacity: 0.6,
                        height: "150%",
                      }}
                    >
                      <MDBIcon
                        fas
                        icon="clinic-medical"
                        color="info"
                        size="3x"
                      />
                      <h6
                        style={{
                          color: "#FEFEFE",
                          fontFamily: " 'Bebas Neue', sans-serif",
                        }}
                      >
                        Deplacer vous pour les soins
                      </h6>
                    </MDBCardBody>
                  </MDBCard>
                </StepLabel>
              </Step>
            </Stepper>
          </Box>
        </MediaQuery>
      </div>

      <Grid container style={{ marginTop: "5%" }}>
        <Grid
          xs={12}
          md={6}
          lg={6}
          alignItems="center"
          justifyContent="center"
          style={{ padding: "2%" }}
        >
          <img
            src={hairloss}
            className="img-fluid rounded"
            style={{ width: "80%", marginLeft: "10%" }}
            alt=""
          />
        </Grid>

        <Grid xs={12} md={6} lg={6} style={{ marginTop: "5%" }}>
          <h1
            style={{
              width: "60%",
              fontFamily: " 'Bebas Neue', sans-serif",
              color: "#54B4D3",
              fontSize: "7vh",
            }}
          >
            Vaincre la Perte de Cheveux : Adoptez la Confiance
          </h1>
          <p style={{ fontFamily: " 'Montserrat', Sans-Serif", width: "70%" }}>
            La perte de cheveux n'est pas seulement une préoccupation esthétique
            ; c'est un problème majeur dans la société d'aujourd'hui. Elle peut
            affecter la confiance en soi, l'estime de soi et la qualité de vie
            globale. Dans un monde où l'apparence compte, traiter la perte de
            cheveux est essentiel pour réussir sur le plan personnel et
            professionnel. Avec notre approche de soin intégrée, nous permettons
            aux individus de reprendre le contrôle, d'augmenter leur confiance
            et de vivre pleinement leur vie.
          </p>

          <p style={{ fontFamily: " 'Montserrat', Sans-Serif", width: "70%" }}>
            Chez Rahima, nous comprenons ces défis et nous sommes là pour vous
            aider à retrouver votre confiance et votre vitalité. Notre approche
            de soin complète va au-delà du traitement traditionnel de la perte
            de cheveux. Nous commençons par une évaluation approfondie de vos
            besoins, puis nous vous guidons à travers chaque étape de votre
            parcours de restauration capillaire. De la consultation initiale à
            nos suivis réguliers, notre équipe dédiée vous accompagne avec
            compassion et expertise. Ne laissez pas la perte de cheveux vous
            freiner. Avec Rahima, vous pouvez non seulement combattre la perte
            de cheveux, mais aussi retrouver votre confiance et votre plein
            potentiel. Découvrez une nouvelle façon de vivre, une vie sans
            limites, où vous êtes libre d'être vous-même.
          </p>
        </Grid>
      </Grid>

      <Box style={{ width: "100%", height: "100%", marginTop: "2%" }}>
        <Grid xs={12} md={12} lg={12} container>
          <Grid
            xs={12}
            md={12}
            lg={12}
            style={{ textAlign: "ceter", alignItems: "center" }}
          >
            <div style={{ textAlign: "center" }}>
              <MDBBtn
                outline
                color="info"
                style={{
                  color: "#54B4D3",
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: "3vh",
                  alignSelf: "center",
                }}
              >
                Pourquoi Nous choisir
              </MDBBtn>

              <p style={{ opacity: "0.8" }}>
                Découvrez pourquoi Rahima est le choix de confiance pour des
                soins de santé de qualité dans notre communauté. Contactez-nous
                dès aujourd'hui pour prendre rendez-vous ou en savoir plus sur
                nos services.{""}
              </p>
            </div>
          </Grid>

          <Grid container alignItems="center" justifyContent="center">
            <Grid xs={12} md={2} lg={2} container>
              <Grid xs={12} md={12} lg={12} container>
                <Grid xs={3} md={3} lg={3}>
                  <MDBIcon
                    fas
                    icon="user-md"
                    style={{
                      background: "#54B4D3",
                      fontSize: "50px",
                      color: "#FEFEFE",
                      borderRadius: "15px",
                      padding: "15%",
                    }}
                  />
                </Grid>
                <Grid xs={9} md={9} lg={9}>
                  <p style={{ fontWeight: "bold", textAlign: "left" }}>
                    Expertise Médicale de Haut Niveau :
                  </p>
                  <p
                    style={{
                      width: "100%",
                      marginTop: "-2%",
                      textAlign: "left",
                    }}
                  >
                    Notre équipe médicale est composée de professionnels
                    hautement qualifiés et expérimentés dans leurs domaines
                    respectifs.
                  </p>
                </Grid>
              </Grid>

              <Grid
                xs={12}
                md={12}
                lg={12}
                container
                style={{ marginTop: "1%" }}
              >
                <Grid xs={3} md={3} lg={3}>
                  <MDBIcon
                    fas
                    icon="clinic-medical"
                    style={{
                      background: "#54B4D3",
                      fontSize: "40px",
                      color: "#FEFEFE",
                      borderRadius: "15px",
                      padding: "15%",
                    }}
                  />
                </Grid>
                <Grid xs={9} md={9} lg={9}>
                  <p style={{ fontWeight: "bold" }}>
                    Médecine Innovante et Précision Diagnostique :
                  </p>
                  <p
                    style={{
                      width: "100%",

                      marginTop: "-2%",
                      textAlign: "left",
                    }}
                  >
                    Notre clinique s'engage à utiliser des technologies
                    médicales avancées pour garantir des diagnostics précis et
                    des traitements efficaces.
                  </p>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={3} lg={3} style={{ textAlign: "center" }}>
              <img
                src={car3d}
                style={{ marginTop: "-10%", width: "100%", padding: "3%" }}
              />
            </Grid>

            <Grid xs={12} md={2} lg={2} container>
              <Grid xs={12} md={12} lg={12} container>
                <Grid xs={3} md={3} lg={3}>
                  <MDBIcon
                    fas
                    icon="user-nurse"
                    style={{
                      background: "#54B4D3",
                      fontSize: "50px",
                      color: "#FEFEFE",
                      borderRadius: "15px",
                      padding: "15%",
                    }}
                  />
                </Grid>
                <Grid xs={9} md={9} lg={9}>
                  <p style={{ fontWeight: "bold", marginLeft: "-2%" }}>
                    Suivi Continu et Support Exceptionnel
                  </p>
                  <p
                    style={{
                      width: "100%",
                      marginLeft: "-2%",
                      marginTop: "-2%",
                      textAlign: "left",
                    }}
                  >
                    Notre engagement envers votre bien-être ne se termine pas à
                    la fin de votre consultation ou de votre traitement. Nous
                    offrons un suivi attentif et continu
                  </p>
                </Grid>
              </Grid>

              <Grid
                xs={12}
                md={12}
                lg={12}
                container
                style={{ marginTop: "1%" }}
              >
                <Grid xs={3} md={3} lg={3}>
                  <MDBIcon
                    fas
                    icon="briefcase-medical"
                    style={{
                      background: "#54B4D3",
                      fontSize: "40px",
                      color: "#FEFEFE",
                      borderRadius: "15px",
                      padding: "15%",
                    }}
                  />
                </Grid>
                <Grid xs={9} md={9} lg={9}>
                  <p style={{ fontWeight: "bold", marginLeft: "-2%" }}>
                    Approche Personnalisée et Attentionnée
                  </p>
                  <p
                    style={{
                      width: "100%",
                      marginLeft: "-2%",
                      marginTop: "-2%",
                      textAlign: "left",
                    }}
                  >
                    Nous comprenons que chaque patient est unique et mérite une
                    attention personnalisée. Chez nous, vous ne serez pas juste
                    un numéro de dossier, mais un individu avec des besoins
                    spécifiques.
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Parallax
        blur={{ min: -15, max: 15 }}
        bgImage={para1}
        bgImageAlt="the dog"
        strength={-200}
        bgImageStyle={{ opacity: "1" }}
        className="para1h"
      >
        <Grid xs={12} md={12} lg={12} container>
          <Grid xs={1} md={1} lg={1}></Grid>
          <Grid
            xs={12}
            md={5}
            lg={5}
            style={{ padding: "2%", textAlign: "center" }}
          >
            <h1
              className="mgup"
              style={{
                fontFamily: " 'Bebas Neue', sans-serif",
                color: "#FEFFFE",
                display: "inline-block",
                marginLeft: "15%",
                fontSize: "5vh",
              }}
            >
              Nous offrons un soin Complet Contre la
              <h1
                style={{
                  color: "#03045E",
                  display: "inline-block",
                  fontSize: "5vh",
                }}
              >
                Perte de Cheveux
              </h1>{" "}
              Notre Approche Intégrée
            </h1>
          </Grid>
          <Grid
            xs={12}
            md={5}
            lg={5}
            style={{ color: "#FEFFFE", textAlign: "center" }}
          >
            <p style={{ marginTop: "20%" }}>
              Après avoir constaté les défis que la perte de cheveux peut poser,
              nous avons conçu une approche de soin complète pour répondre à vos
              besoins individuels. De la première consultation jusqu'au suivi
              régulier, notre équipe dévouée est là pour vous accompagner à
              chaque étape de votre parcours de restauration capillaire.
            </p>
          </Grid>

          <Grid xs={12} md={12} lg={12} container>
            <Grid xs={2} md={2} lg={2}></Grid>
            <Grid
              xs={12}
              md={2}
              lg={2}
              style={{
                textAlign: "center",
                borderRadius: "15px",
                padding: "2%",
              }}
            >
              <MDBCard
                style={{
                  backgroundColor: "#CAF0F8",
                  fontFamily: " 'Bebas Neue', sans-serif",
                }}
              >
                <MDBCardBody
                  style={{
                    backgroundColor: "#CAF0F8",
                    borderRadius: "15px",
                    height: "150%",
                  }}
                >
                  <h3 style={{ color: "#03045E" }}>Diagnostic Personnalisé </h3>
                </MDBCardBody>
              </MDBCard>
            </Grid>

            <Grid
              xs={12}
              md={2}
              lg={2}
              style={{
                textAlign: "center",
                borderRadius: "15px",
                padding: "2%",
              }}
            >
              <MDBCard
                style={{
                  backgroundColor: "#CAF0F8",
                  fontFamily: " 'Bebas Neue', sans-serif",
                }}
              >
                <MDBCardBody
                  style={{
                    backgroundColor: "#CAF0F8",
                    borderRadius: "15px",
                    height: "150%",
                  }}
                >
                  <h3 style={{ color: "#03045E" }}>Intervention Complète</h3>
                </MDBCardBody>
              </MDBCard>
            </Grid>

            <Grid
              xs={12}
              md={2}
              lg={2}
              style={{
                textAlign: "center",
                borderRadius: "15px",
                padding: "2%",
              }}
            >
              <MDBCard
                style={{
                  backgroundColor: "#CAF0F8",
                  fontFamily: " 'Bebas Neue', sans-serif",
                }}
              >
                <MDBCardBody
                  style={{
                    backgroundColor: "#CAF0F8",
                    borderRadius: "15px",
                    height: "150%",
                  }}
                >
                  <h3 style={{ color: "#03045E" }}>
                    Soutien Continu de qualite
                  </h3>
                </MDBCardBody>
              </MDBCard>
            </Grid>

            <Grid
              xs={12}
              md={2}
              lg={2}
              style={{
                textAlign: "center",
                borderRadius: "15px",
                padding: "2%",
              }}
            >
              <MDBCard
                style={{
                  backgroundColor: "#CAF0F8",
                  fontFamily: " 'Bebas Neue', sans-serif",
                  fontWeight: "bolder",
                }}
              >
                <MDBCardBody
                  style={{
                    backgroundColor: "#CAF0F8",
                    borderRadius: "15px",
                    height: "150%",
                  }}
                >
                  <h3 style={{ color: "#03045E" }}>Suivi Intégré et continu</h3>
                </MDBCardBody>
              </MDBCard>
            </Grid>
          </Grid>
        </Grid>
        <div style={{ height: "600px" }} />
      </Parallax>

      <Grid container style={{ marginTop: "5%" }}>
        <Grid xs={12} md={6} lg={6}>
          <h1
            style={{
              width: "60%",
              marginLeft: "8%",
              fontFamily: " 'Bebas Neue', sans-serif",
              color: "#141414",
              fontSize: "7vh",
            }}
          >
            Prenez RDV et consultez en ligne directement
          </h1>

          <p style={{ width: "65%", marginLeft: "8%" }}>
            Dans notre engagement à fournir des soins de qualité et accessibles,
            nous offrons des consultations en ligne avec des médecins
            spécialisés. Grâce à cette option pratique, vous pouvez bénéficier
            de conseils d'experts depuis le confort de votre foyer. Nos médecins
            spécialisés sont là pour répondre à vos questions, discuter de vos
            préoccupations et vous guider vers les meilleures solutions pour vos
            besoins capillaires.
          </p>

          <MDBListGroup style={{ minWidth: "22rem", width: "70%" }} light>
            <MDBListGroupItem
              className="d-flex justify-content-between align-items-center"
              style={{ marginLeft: "10%" }}
            >
              <div>
                <div className="fw-bold">Remplissez les Informations</div>
                <div className="text-muted">
                  Commencez par fournir vos informations exactes sans erreurs et
                  prenez des photos appropriées de votre situation capillaire
                  actuelle.
                </div>
              </div>
              <MDBBadge pill dark color="info">
                1
              </MDBBadge>
            </MDBListGroupItem>
            <MDBListGroupItem
              className="d-flex justify-content-between align-items-center"
              style={{ marginLeft: "10%" }}
            >
              <div>
                <div className="fw-bold">
                  Teleconsultation avec un Médecin Spécialisé
                </div>
                <div className="text-muted">
                  Après avoir soumis vos informations, vous aurez une
                  teleconsultation avec un médecin spécialisé.
                </div>
              </div>
              <MDBBadge pill dark color="info">
                2
              </MDBBadge>
            </MDBListGroupItem>
            <MDBListGroupItem
              className="d-flex justify-content-between align-items-center"
              style={{ marginLeft: "10%" }}
            >
              <div>
                <div className="fw-bold">Examen Approfondi à la Clinique</div>
                <div className="text-muted">
                  : Après la teleconsultation , vous serez invité à venir à la
                  clinique pour un examen approfondi et des tests
                  supplémentaires
                </div>
              </div>
              <MDBBadge pill dark color="info">
                3
              </MDBBadge>
            </MDBListGroupItem>
          </MDBListGroup>
          <a href="/Login">
            <MDBBtn
              color="info"
              style={{
                color: "#54B4D3",
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: "3vh",
                marginLeft: "8%",
              }}
            >
              <p style={{ color: "#141414" }}>Prenez RDV des maintenant</p>
            </MDBBtn>
          </a>
        </Grid>
        <Grid xs={12} md={6} lg={6} style={{ padding: "2%" }}>
          <Carousel fade interval={2000}>
            <Carousel.Item style={{ height: "50%" }}>
              <img src={c3} style={{ height: "700px", borderRadius: "15px" }} />
              <Carousel.Caption>
                <h3>First slide label</h3>
                <p>
                  Nulla vitae elit libero, a pharetra augue mollis interdum.
                </p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item style={{ height: "700px" }}>
              <img
                src={c1}
                text="Second slide"
                style={{ height: "700px", borderRadius: "15px" }}
              />
              <Carousel.Caption>
                <h3>Second slide label</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item style={{ height: "700px" }}>
              <img
                src={c2}
                text="Third slide"
                style={{ height: "700px", borderRadius: "15px" }}
              />
              <Carousel.Caption>
                <h3>Third slide label</h3>
                <p>
                  Praesent commodo cursus magna, vel scelerisque nisl
                  consectetur.
                </p>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </Grid>
      </Grid>

      <MDBContainer className="py-5">
        <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" xl="8" className="text-center">
            <h3 className="mb-4">Testimonials</h3>
            <p className="mb-4 pb-2 mb-md-5 pb-md-0">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit,
              error amet numquam iure provident voluptate esse quasi, veritatis
              totam voluptas nostrum quisquam eum porro a pariatur veniam.
            </p>
          </MDBCol>
        </MDBRow>
        <MDBRow className="text-center">
          <MDBCol md="6" className="mb-4 mb-md-0">
            <div className="d-flex justify-content-center mb-4">
              <img
                src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(22).webp"
                class="rounded-circle shadow-1-strong"
                width="100"
                height="100"
              />
            </div>
            <p className="lead my-3 text-muted">
              "Grâce à la clinique, ma confiance est restaurée ! Les résultats
              des implants capillaires sont naturels et le processus était
              facile. Je recommande vivement cette clinique."
            </p>
            <p className="font-italic font-weight-normal mb-0">- Anna Morian</p>
          </MDBCol>
          <MDBCol md="6" className="mb-4 mb-md-0">
            <div className="d-flex justify-content-center mb-4">
              <img
                src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(19).webp"
                class="rounded-circle shadow-1-strong"
                width="100"
                height="100"
              />
            </div>
            <p className="lead my-3 text-muted">
              "Les implants capillaires ont dépassé mes attentes ! L'équipe
              était professionnelle et les résultats sont incroyables. Je
              recommande cette clinique sans hésiter."
            </p>
            <p className="font-italic font-weight-normal mb-0">- Teresa May</p>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      <Grid container>
        <Grid
          xs={12}
          md={12}
          lg={12}
          style={{
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <h1
            className="mb-5"
            style={{ fontFamily: " 'Bebas Neue', sans-serif" }}
          >
            Contact us
          </h1>
        </Grid>
        <Grid
          xs={12}
          md={6}
          lg={6}
          style={{
            alignItems: "flex-end",
            justifyContent: "flex-end",
            paddingRight: "2%",
          }}
          display="flex"
          justifyContent="flex-end"
        >
          <section className=" text-center mb-4 ">
            <div className="row">
              <div className="col-lg-5">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12830.376484165834!2d2.8519777!3d36.4915181!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x128f0b75b47d0015%3A0x7dfe55f0188ef7d3!2sClinique%20rahima!5e0!3m2!1sfr!2sdz!4v1713278661922!5m2!1sfr!2sdz"
                  width="500px"
                  height="450"
                  style={{ border: "0" }}
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </section>
        </Grid>
        <Grid
          xs={12}
          md={6}
          lg={6}
          style={{ marginTop: "1%", paddingLeft: "2%" }}
        >
          <MDBCard
            style={{ maxWidth: "540px", borderRadius: "16px", padding: "5%" }}
          >
            <MDBRow className="g-0">
              <MDBCol md="4">
                <MDBCardImage
                  src={logorahima}
                  alt="..."
                  fluid
                  style={{
                    borderTopLeftRadius: "16px",
                    borderBottomLeftRadius: "16px",
                    marginTop: "100%",
                  }}
                />
              </MDBCol>
              <MDBCol md="8">
                <MDBCardBody>
                  <MDBListGroup light className="mb-4">
                    <MDBListGroupItem className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <MDBIcon
                          fas
                          icon="map-marker-alt"
                          size="lg"
                          color="info"
                        />
                        <div className="ms-3">
                          <p className="fw-bold mb-1">
                            Cite Russe N°18 Ouled Yaich, Blida
                          </p>
                        </div>
                      </div>
                    </MDBListGroupItem>

                    <MDBListGroupItem className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <MDBIcon fas icon="phone" size="lg" color="info" />
                        <div className="ms-3">
                          <p className="fw-bold mb-1">+213 549 44 51 77</p>
                        </div>
                      </div>
                    </MDBListGroupItem>
                    <MDBListGroupItem className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <MDBIcon fas icon="phone" size="lg" color="info" />
                        <div className="ms-3">
                          <p className="fw-bold mb-1">+213 549 28 02 71</p>
                        </div>
                      </div>
                    </MDBListGroupItem>
                    <MDBListGroupItem className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <MDBIcon fas icon="phone" size="lg" color="info" />
                        <div className="ms-3">
                          <p className="fw-bold mb-1"> +213 771 83 63 44</p>
                        </div>
                      </div>
                    </MDBListGroupItem>

                    <MDBListGroupItem className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <MDBIcon far icon="envelope" size="lg" color="info" />
                        <div className="ms-3">
                          <p className="fw-bold mb-1">
                            greffecheveux@gmail.com
                          </p>
                        </div>
                      </div>
                    </MDBListGroupItem>
                  </MDBListGroup>
                </MDBCardBody>
              </MDBCol>
            </MDBRow>
          </MDBCard>
        </Grid>
      </Grid>

      <MDBFooter
        bgColor="light"
        className="text-center text-lg-start text-muted"
      >
        <section className="">
          <MDBContainer className="text-center text-md-start mt-5">
            <MDBRow className="mt-3" style={{ marginTop: "2%" }}>
              <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
                <img
                  src={logonobg}
                  style={{ width: "100px", height: "100px" }}
                />
                <h2
                  style={{
                    fontFamily: " 'Bebas Neue', sans-serif",
                    textAlign: "left  ",
                  }}
                >
                  centre de Diagnostic medicale
                </h2>
              </MDBCol>

              <MDBCol
                md="2"
                lg="2"
                xl="2"
                className="mx-auto mb-4"
                style={{ marginTop: "2%" }}
              >
                <h6 className="text-uppercase fw-bold mb-4">Liens Utiles</h6>
                <p>
                  <a href="/Login" className="text-reset">
                    TeleConsultation
                  </a>
                </p>

                <p>
                  <a href="/about" className="text-reset">
                    Qui sommes nous ?
                  </a>
                </p>
              </MDBCol>

              <MDBCol md="4" lg="3" xl="3" className="mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
                <p>
                  <MDBIcon icon="home" className="me-2" color="info" />
                  Cite Russe N°18 Ouled Yaich, Blida
                </p>
                <p>
                  <MDBIcon icon="envelope" className="me-3" color="info" />
                  greffecheveux@gmail.com
                </p>
                <p>
                  <MDBIcon icon="phone" className="me-3" color="info" /> + 213
                  549 44 51 77
                </p>
                <p>
                  <MDBIcon icon="print" className="me-3" color="info" /> 
                </p>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </section>
      </MDBFooter>
    </div>
  );
}



export default  (Home);
